import React from 'react';

const Spinner = ({ className }) => <i className={"fas fa-spinner fa-spin " + (className || "")}></i>

export default Spinner;